// Efeito de exibição: planos de teste (trial, trial_workshop, trial_bussiness, trial_assistance...)
// aparecem como "Grátis" para o usuário. Não usar em comparações lógicas nem em payloads.
const TRIAL_PLAN_REGEX = /^(trial(_|$)|gr[aá]tis\s+14\s+dias$)/i;

export const isTrialPlanName = (name) => typeof name === 'string' && TRIAL_PLAN_REGEX.test(name.trim());

export const planDisplayName = (name) => {
  if (typeof name !== 'string') return name;
  return isTrialPlanName(name) ? 'Grátis' : name;
};

export default planDisplayName;
